


























































import { Component, Prop, Vue } from "vue-property-decorator";
import { ButtonVariant } from "@/types";

const LOADING_TIMEOUT_SECONDS = 5;

enum State {
  CHECKING = "checking",
  SUCCESSFUL = "successful",
  FAILED = "failed"
}

@Component
export default class CheckEmbeddingPreview extends Vue {
  $refs!: {
    iframe: HTMLFrameElement;
  };

  $enums = {
    ButtonVariant,
    State
  };

  @Prop({ required: true }) url!: string;

  loading = false;
  state = State.CHECKING;
  interval: number | null = null;
  startTime = 0;
  elapsedTimeSeconds = "";

  mounted(): void {
    this.startCheck();
  }

  startCheck(): void {
    this.stopTimer();

    this.startTime = new Date().getTime();
    this.elapsedTimeSeconds = "0.0";
    this.loading = true;

    this.interval = setInterval(() => {
      const now = new Date().getTime();
      const millis = Math.max(0, now - this.startTime);
      const seconds = Math.floor(millis / 1000);
      const tenths = Math.floor((millis - seconds * 1000) / 100);

      this.elapsedTimeSeconds = seconds + "." + tenths;

      if (millis >= LOADING_TIMEOUT_SECONDS * 1000) {
        this.setResult(State.FAILED);
      }
    }, 100);
  }

  onLoad(): void {
    this.stopTimer();
    this.loading = false;
    if (this.state === State.CHECKING) {
      this.setResult(State.SUCCESSFUL);
    }
  }

  stopTimer(): void {
    if (this.interval) {
      clearTimeout(this.interval);
      this.interval = null;
    }
  }

  setResult(state: State): void {
    this.state = state;
  }

  confirm(): void {
    this.$emit("confirm", this.url);
  }

  reject(): void {
    this.$emit("reject", this.url);
  }
}
